<div class="searchbar p-relative d-lg-none d-block">
  <div id="searchDiv" [ngClass]="show ? 'searchbar-open' : ''">
    <input id="searchInputIn" [(ngModel)]="text" autofocus (keyup)="getCustomer($event)" type="text"
      placeholder="Search" />
    <button *ngIf="show" class="close"><img src="assets/images/cross.png" alt="icon"
        (click)="closeSearchBar()"></button>
    <button><img src="assets/images/search-icon-dark.svg" alt="icon"
        (click)="getCustomer($event, true)"></button>
    <div class="searchbar-content" *ngIf="show">
      <span *ngIf="productList && productList.length > 0">PRODUCTS</span>
      <ul *ngIf="productList && productList.length > 0">
        <li *ngFor="let product of productList; let i = index"><a (click)="showProduct(product)">{{product.name}}</a>
        </li>
      </ul>
      <span *ngIf="brandList && brandList.length > 0">Brands</span>
      <ul *ngIf="brandList && brandList.length > 0">
        <li *ngFor="let brand of brandList; let i = index">
          <a (click)="viewBrandDetail(brand)">{{brand.name}}</a>
        </li>
      </ul>
      <span *ngIf="categoryList && categoryList.length > 0">Sub Categories</span>
      <ul *ngIf="categoryList && categoryList.length > 0">
        <li *ngFor="let category of categoryList; let i = index">
          <a
            (click)="goToShopAll(category.subCategory_name,category.category_id,category.subCategory_id)">{{category.subCategory_name}}</a>
        </li>
      </ul>
      <span *ngIf="skinConcernsList && skinConcernsList.length > 0">Skin Concerns</span>
      <ul *ngIf="skinConcernsList && skinConcernsList.length > 0">
        <li *ngFor="let skinConcern of skinConcernsList; let i = index">
          <a
            (click)="goToShopAllWithSkinConcern(skinConcern.name,skinConcern.category_id,skinConcern.id)">{{skinConcern.name}}</a>
        </li>
      </ul>
      <span *ngIf="skinTypeList && skinTypeList.length > 0">SkinTypes</span>
      <ul *ngIf="skinTypeList && skinTypeList.length > 0">
        <li *ngFor="let skinType of skinTypeList; let i = index">
          <a (click)="goToShopAllWithSkinType(skinType.name,skinType.category_id,skinType.id)">{{skinType.name}}</a>
        </li>
      </ul>
    </div>
  </div>
</div>